import * as tts from "./common/tts";
var debug = false;
var searchParams = new URLSearchParams(window.location.search);
debug = searchParams.has('debug') ? !!searchParams.get('debug') : false;
var initAnalytics = function (context, segment) {
    var paywallElement = document.querySelector('.paywall-banner');
    if (!paywallElement) {
        debug && logDebug("Paywall banner isn't rendered. Aborting the analytics");
        return;
    }
    var main = document.querySelector('main');
    var route = main === null || main === void 0 ? void 0 : main.getAttribute('data-route');
    if (!route) {
        debug && logDebug('Can not retrieve route to initialize analytics, aborting');
        return;
    }
    tts.custom({
        event: 'paywall_charged',
        uri: document.location,
        utm_content: segment,
        utm_source: context
    }, route);
    debug && logDebug("Added the analytics hit with the event: %c'paywall_charged'", 'font-style: italic; color: #DC3635');
    initAnalyticsView(paywallElement, segment, route, context);
    initAnalyticsClick(paywallElement, segment, context);
};
var initAnalyticsView = function (paywallElement, segment, route, context) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                debug && logDebug("Intersecting. Adding the analytics hit with the event: %c'paywall_view'", 'font-style: italic; color: #DC3635');
                tts.custom({
                    event: 'paywall_view',
                    uri: document.location,
                    utm_content: segment,
                    utm_source: context
                }, route);
                observer.unobserve(entry.target);
            }
        });
    });
    observer.observe(paywallElement);
};
var initAnalyticsClick = function (paywallElement, segment, context) {
    var actionLink = paywallElement.querySelector('.btn');
    if (!actionLink) {
        return;
    }
    actionLink.addEventListener('click', function (e) {
        debug && logDebug("Action button fired. Adding the analytics hit with the event: %c'click'", 'font-style: italic; color: #DC3635');
        e.preventDefault();
        tts.click(actionLink.href, { utm_content: segment, utm_source: context, utm_campaign: 'paywall' })
            .then(function () {
            localStorage.setItem('pw_context', context);
            localStorage.setItem('pw_segment', segment);
            window.location.href = actionLink.href;
        });
    });
};
var logDebug = function (message, context) {
    console.log("%cPaywall%c " + message, 'color: white; background-color: #8533ff; padding: 2px 5px; border-radius: 2px', 'color: auto; background-color: none; padding: none; border-radius: none', context !== null && context !== void 0 ? context : '');
};
export { initAnalytics };
